import React from 'react';
import { useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import './UserExistsModal.css';

const UserExistsModal = ({ isOpen, onClose }) => {
	const navigate = useNavigate();

	if (!isOpen) return null;

	const handleSignIn = () => {
		onClose();
		navigate('/login');
	};

	return (
		<div className="user-exists-modal__overlay" onClick={onClose}>
			<div className="user-exists-modal__content" onClick={e => e.stopPropagation()}>
				<h2 className="user-exists-modal__header">User already exists</h2>
				<p className="user-exists-modal__body">
					Please{' '}
					<button
						type="button"
						className="user-exists-modal__link"
						onClick={handleSignIn}
					>
						login to your account here
					</button>
				</p>
				<button
					type="button"
					className="user-exists-modal__close"
					onClick={onClose}
					aria-label="Close modal"
				>
					<CloseIcon />
				</button>
			</div>
		</div>
	);
};

export default UserExistsModal;
